<template>
  <ul class="form-item-list">
    <li><h3><b>최근 1년 이내에</b> 다음과 같은 취미를 자주 반복적으로 하고 있거나 관련 자격증을 가지고 있습니까?</h3></li>
    <li>
      <p>1. 스쿠버다이빙</p>
      <p>2. 행글라이딩,패러글라이딩</p>
      <p>3. 스카이다이빙</p>
      <p>4. 수상스키</p>
      <p>5. 자동차,오토바이 경주</p>
      <p>6. 번지점프</p>
      <p>7. 방벽, 암벽등반</p>
      <p>8. 제트스키</p>
      <p>9. 래프팅</p>
    </li>
    <li class="text-center">
      <el-checkbox
        class="round"
        label="예"
        border
        v-model="yes"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'yes')"
      />
      <el-checkbox
        class="round"
        label="아니오"
        border
        v-model="no"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'no')"
      />
    </li>
    <li v-if="yes">
      <div class="detail-form">
        <el-row :gutter="20" class="my-1">
          <div class="label mx-0">{{ detail['빈도'].label }}</div>
          <el-col :span="12">
            <element-select
              v-model="detail['빈도'].value[0].value"
              :error="detail['빈도'].value[0].error"
              :label="detail['빈도'].value[0].label"
              :items="detail['빈도'].value[0].items"
              :placeholder="detail['빈도'].value[0].placeholder"
              @input="(value) => changeSelectEventHandler('빈도', 0, value)"
            />
          </el-col>
          <el-col :span="12">          
            <el-input
              type="text"
              v-model="detail['빈도'].value[1].value"
              :placeholder="detail['빈도'].value[1].placeholder"
              @input="changeDetail('빈도')"
            >
              <span slot="suffix">회</span>
            </el-input>
          </el-col>
        </el-row>

        <el-row>
          <element-textbox
            v-model="detail['자격증명칭'].value"
            :error="detail['자격증명칭'].error"
            :label="detail['자격증명칭'].label"
            :placeholder="detail['자격증명칭'].placeholder"
            @input="changeDetail('자격증명칭')"
          />
        </el-row>
      </div>
    </li>
  </ul>
</template>

<script>
import { Checkbox, Row, Col, Input } from 'element-ui';

export default {
  name: 'Certificate',
  props: ['formData'],
  components: {
    [Checkbox.name]: Checkbox,
    [Row.name]: Row,
    [Col.name]: Col,
    [Input.name]: Input,
  },
  data() {
    return {
      yes: this.formData.answer.value === '예',
      no: this.formData.answer.value === '아니오',
      detail: {
        '빈도': {
          label: "빈도",
          value: [
            {
              value: '연간',
              items: [
                { label: '연간', value: '연간' },
                { label: '월간', value: '월간' },
                { label: '주간', value: '주간' },
                { label: '일간', value: '일간' },
              ]
            },
            { placeholder: '예:10', value: '' },
          ],
          error: "",
          placeholder: "빈도",
          validations: [
            { type: "required", message: "필수항목입니다" }
          ]
        },
        '자격증명칭': {
          label: "자격증 명칭",
          placeholder: '자격증 명칭을 입력해주세요',
          value: "",
          error: "",
          validations: [
            { type: "required", message: "필수항목입니다" }
          ],
        },
      }
    }
  },
  mounted() { 
    this.$emit('update', { type: '빈도', value: { '주기': '', '횟수': '' } });
    this.$emit('update', { type: '자격증명칭', value: '' });
  },
  methods: {
    updateChecked(event, type) {
      const reverse = type === 'yes' ? 'no' : 'yes';
      this.$data[reverse] = !event;
      this.$emit('update', { type: 'answer', value: type });
    },
    changeDetail(key) {
      let updateData = {
        type: '빈도',
        value: {
          '주기': '',
          '횟수': '',
        }
      };

      if (key !== '빈도') {
        this.$emit('update', { type: key, value: this.detail[key].value });
        return;
      }

      updateData.value = {
        ...updateData.value,
        주기: this.detail['빈도'].value[0].value,
        횟수: this.detail['빈도'].value[1].value
      };

      this.$emit('update', updateData);
    },
    changeSelectEventHandler(key, index, value) {
      let data = this.detail[key][index];
      data.value = value;
      
      this.$emit('update', { type: key, value: this.detail[key] });
    },
  }
}
</script>

<style lang="scss" scoped>
.form-item-list {
  li {
    &.text-center {
      text-align: center;
    }
    h3 {
      font-size: 18px !important;
    }
    p {
      span.blue {
        color: #174BE6;
      }
    }
    .el-checkbox {
      &.round {
        width: 40%;
        text-align: left;

        .el-checkbox__inner {
          border-radius: 50% !important;
        }
      }
    }
  }
  .detail-form {
    h3 {
      margin-bottom: 2*$unit;
    }
    .el-row {
      margin-bottom: 2*$unit;

      &.my-1 {
        margin-bottom: $unit;
      }
      .mx-0 {
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: $unit;
      }
      .el-input {
        height: 54px;
  
        .el-input__inner {
          height: 54px;
          border-radius: 0;
        }
  
        .el-input__suffix-inner {
          line-height: 54px;
          color: #000;
        }
      }

      .element-select {
        .label {
          display: none;
        }
        .body {
          margin-top: 0;
        }
      }

      .element-radio {
        display: flex;
        justify-content: space-between;

        ul {
          li {
            margin-top: 0 !important;
            padding-right: 2*$unit;

            &::before {
              width: 1.5*$unit;
              height: 1.5*$unit;
            }
            &::after {
              width: 0.8*$unit;
              transform: rotate(-45deg) translateX(0.4rem) translateY(0.2rem);
            }
          }
        }
      }
    }
  }
}
</style>